import React, { useState, useEffect } from 'react';
import styled, { keyframes } from 'styled-components';
import { connect } from 'react-redux';
import { sendTextMessage, sendUserAction } from '../../../../reducers/history/actions';
import CheckIcon from '../../../../components/icons/CheckIcon';
import CrossIcon from '../../../../components/icons/CrossIcon';

const ButtonsContainer = styled.div`
  display: flex;
  gap: 8px;
  width: 100%;
`;

const clickEffect = keyframes`
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(0.97);
  }
  100% {
    transform: scale(1);
  }
`;

const BaseButton = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 12px 16px;
  border-radius: 24px;
  border: 1px solid #e5e7eb;
  font-size: 14px;
  cursor: pointer;
  transition: all 0.2s;
  flex: 1;
  min-height: 48px;
  background: white;
  color: ${props => props.theme.botMessageFontColor};

  &:hover {
    background: ${props => props.theme.userMessageBubbleColor || '#3b82f6'};
    color: ${props => props.theme.userMessageFontColor || 'white'};
    border-color: ${props => props.theme.userMessageBubbleColor || '#3b82f6'};
  }
`;

const YesButton = styled(BaseButton)`
  &[data-selected='true'] {
    background: ${props => props.theme.userMessageBubbleColor || '#065f46'};
    border-color: ${props => props.theme.userMessageBubbleColor || '#065f46'};
    color: ${props => props.theme.userMessageFontColor || 'white'};
    font-weight: 500;
    pointer-events: none;
    animation: ${clickEffect} 0.3s ease-out;
  }
`;

const NoButton = styled(BaseButton)`
  &[data-selected='true'] {
    background: ${props => props.theme.userMessageBubbleColor || '#991b1b'};
    border-color: ${props => props.theme.userMessageBubbleColor || '#991b1b'};
    color: ${props => props.theme.userMessageFontColor || 'white'};
    font-weight: 500;
    pointer-events: none;
    animation: ${clickEffect} 0.3s ease-out;
  }
`;

const YesNoButtons = ({ sendTextMessage, sendUserAction, activity }) => {
  const [selectedButton, setSelectedButton] = useState(null);

  // Extract actions from activity
  const actions = activity.suggestedActions.actions;

  // Check if there's a saved user selection
  useEffect(
    () => {
      // Check for array format (userActions)
      if (activity && activity.userActions) {
        const savedAction = activity.userActions.find(action =>
          action.startsWith('choice_selected:')
        );

        if (savedAction) {
          const savedValue = savedAction.split(':')[1].toLowerCase();
          setSelectedButton(savedValue);
          return;
        }
      }

      // Check for string format (userAction)
      if (activity && activity.userAction && typeof activity.userAction === 'string') {
        if (activity.userAction.startsWith('choice_selected:')) {
          const savedValue = activity.userAction.split(':')[1].toLowerCase();
          setSelectedButton(savedValue);
        }
      }
    },
    [activity]
  );

  const handleClick = action => {
    const value = action.value.toLowerCase();
    setSelectedButton(value);

    // Send text message
    sendTextMessage({
      text: action.value,
      choiceNodeOriginText: action.choiceNodeOriginText
    });

    // Save user selection
    if (activity && activity.id) {
      sendUserAction(`choice_selected:${value}`, activity.id);
    }
  };

  const yesAction = actions.find(a => a.value.toLowerCase() === 'yes');
  const noAction = actions.find(a => a.value.toLowerCase() === 'no');

  return (
    <ButtonsContainer>
      <YesButton
        onClick={() => handleClick(yesAction)}
        data-selected={selectedButton === 'yes'}
        disabled={selectedButton !== null}
      >
        <CheckIcon /> YES
      </YesButton>
      <NoButton
        onClick={() => handleClick(noAction)}
        data-selected={selectedButton === 'no'}
        disabled={selectedButton !== null}
      >
        <CrossIcon /> NO
      </NoButton>
    </ButtonsContainer>
  );
};

export default connect(null, { sendTextMessage, sendUserAction })(YesNoButtons);



// WEBPACK FOOTER //
// ./src/components/MessageHistory/BotMessage/ActionButtons/YesNoButtons.js